import { ReactNode } from "react";
import { Href } from "expo-router";

import { I18nKeyType } from "@/i18n";
import {
  AccountSidebarFilledIcon,
  AccountSidebarOutlineIcon,
} from "@/theme/icons/AccountSidebarIcon";
import {
  HouseholdSidebarFilledIcon,
  HouseholdSidebarOutlineIcon,
} from "@/theme/icons/HouseholdSidebarIcon";

export type SidebarItemType = {
  i18nKey: I18nKeyType;
  href: Href;
  ActiveIcon: ReactNode;
  InactiveIcon?: ReactNode;
};

export const sidebarItems: SidebarItemType[] = [
  {
    i18nKey: "native:appMenu.household",
    href: "/(authed)",
    ActiveIcon: <HouseholdSidebarFilledIcon />,
    InactiveIcon: <HouseholdSidebarOutlineIcon />,
  },
  {
    i18nKey: "native:appMenu.account",
    href: "/(authed)/account",
    ActiveIcon: <AccountSidebarFilledIcon />,
    InactiveIcon: <AccountSidebarOutlineIcon />,
  },
];
